/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsGet } from "../funcs/organizationsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Organization } from "../models/components/organization.js";
import {
  GetOrganizationRequest,
  GetOrganizationSecurity,
} from "../models/operations/getorganization.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationQueryData = Organization;

export function prefetchOrganization(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetOrganizationRequest | undefined,
  security?: GetOrganizationSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationQuery(
  client$: GramCore,
  request?: GetOrganizationRequest | undefined,
  security?: GetOrganizationSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<OrganizationQueryData>;
} {
  return {
    queryKey: queryKeyOrganization({ gramSession: request?.gramSession }),
    queryFn: async function organizationQueryFn(
      ctx,
    ): Promise<OrganizationQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganization(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizations", "get", parameters];
}
